import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { JiraAppSelectorIconWithGithub } from './jira-app-selector-with-github';
import { messages } from './messages';

const styles = cssMap({
	moreButtonStyles: {
		alignItems: 'center',
		backgroundColor: token('elevation.surface.sunken'),
		border: `${token('border.width')} solid ${token('color.border.inverse')}`,
		borderRadius: token('radius.small'),
		display: 'flex',
		paddingLeft: token('space.100'),
		paddingRight: token('space.075'),
	},
	iconsStyles: {
		display: 'flex',
		translate: token('space.025'),
	},
});

/**
 * Variant of AllAppsIcon that includes the GitHub icon in the pill group.
 * Used when the github_icon_in_jira_all_apps_experiment is enabled.
 */
export const AllAppsIconWithGithub: () => React.JSX.Element = () => {
	const { formatMessage } = useIntl();

	return (
		<Flex role="presentation" alignItems="center" testId="all-apps-icon-with-github">
			<Box xcss={styles.iconsStyles}>
				<JiraAppSelectorIconWithGithub />
			</Box>

			<Box xcss={styles.moreButtonStyles}>
				<Text size="small" align="center" color="color.text.subtle">
					{formatMessage(messages.more)}
				</Text>
			</Box>
		</Flex>
	);
};
